import { UserCreditData } from '@/pages/home/types';
import { PocketMoneyStatusEnum } from '@/api/homeV2Status/types';

/** 消息提示配置 */
interface MessageConfig {
  /** 消息提示名称 */
  name: string;
  /** 消息提示文案 */
  noticeText: string;
  /** 最多曝光次数 */
  exposeMaxCount: number;
  /** 最多关闭次数 */
  closeMaxCount: number;
  /** 是否展示条件 */
  isShow: (userCreditData: UserCreditData) => boolean;
}

/** 零用钱提现失败提示配置 */
const pocketMoneyTipsConfig: MessageConfig = {
  name: 'pocketMoneyTips',
  noticeText: '很抱歉，哈啰零用钱提现失败，可申请其他额度',
  exposeMaxCount: 2,
  closeMaxCount: 1,
  isShow: (userCreditData: UserCreditData): boolean => {
    const { pocketMoneyStatus } = userCreditData;
    const isLentFailed = pocketMoneyStatus === PocketMoneyStatusEnum.LEND_FAILED;
    return isLentFailed;
  },
};

/** 消息提示配置列表 */
export const messageConfigList: MessageConfig[] = [pocketMoneyTipsConfig];
